export { NotFoundPageContainer as NotFoundPage } from "./container";
